import type { ComponentPropsWithRef, FC } from 'react';

import { memo } from 'react';
import isEqual from 'react-fast-compare';
import styled from 'styled-components';

const S = {
  ProgressBarContainer: styled.div`
    position: absolute;
    z-index: 2;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 4px;
    background-color: ${({ theme }) => theme.colors.neutral[200]};
    overflow: hidden;
  `,
  ProgressBarFill: styled.div<{ $progress: number }>`
    height: 100%;
    width: ${({ $progress }) => $progress}%;
    background-color: ${({ theme }) => theme.colors.slate[900]};
    transition: width 0.3s ease-out;

    @media (prefers-reduced-motion: reduce) {
      transition-duration: 0s;
    }
  `,
};

interface Props extends ComponentPropsWithRef<'div'> {
  progress: number;
}

const ProgressBarComponent: FC<Props> = ({ progress, ref, ...rest }) => (
  <S.ProgressBarContainer {...rest}>
    <S.ProgressBarFill ref={ref} $progress={progress} data-testid="progress-bar-fill" />
  </S.ProgressBarContainer>
);

export const ProgressBar = memo(ProgressBarComponent, isEqual);
